import { generatePath } from 'react-router-dom';
import frontendLog from '../libs/frontendLog';

export function resolveRoutePath(path: string, params?: Object): string {
  try {
    return generatePath(path, params);
  } catch (err) {
    frontendLog.error({ err, path, params }, 'resolveRoutePath failed');
    return '/';
  }
}
